import { render, staticRenderFns } from "./EmailCollectRefusePop.vue?vue&type=template&id=dd428d28"
import script from "./EmailCollectRefusePop.vue?vue&type=script&lang=js"
export * from "./EmailCollectRefusePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd428d28')) {
      api.createRecord('dd428d28', component.options)
    } else {
      api.reload('dd428d28', component.options)
    }
    module.hot.accept("./EmailCollectRefusePop.vue?vue&type=template&id=dd428d28", function () {
      api.rerender('dd428d28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/popup/EmailCollectRefusePop.vue"
export default component.exports